//#region ../base/api/list-operation/index.ts
function constructListQuery(q, i = 0) {
	const strings = q.children.map((child) => {
		if (typeof child === "object") return constructListQuery(child, i + 1);
		return child?.trim();
	}).filter(Boolean);
	if (!strings.length) return "";
	const inner = strings.join(` ${q.operator} `).trim();
	return i === 0 ? inner : `( ${inner} )`;
}
function constructSortString(sort) {
	return (sort ?? []).map((s) => {
		if (s && typeof s === "object" && "field" in s && "order" in s && s.field && s.order) return `${s.field}:${s.order}`;
		if (s && typeof s === "string") return s;
	}).filter(Boolean).join(",");
}
function parseListParams(usp, params) {
	if (params?.page) usp.set("page", String(params.page));
	if (params?.page_length) usp.set("page_length", String(params.page_length));
	usp.delete("sort");
	usp.delete("q");
	if (params?.sort) {
		const str = constructSortString(params.sort);
		if (str) usp.set("sort", str);
	}
	if (params?.q) {
		const str = typeof params.q === "string" ? params.q.trim() : constructListQuery(params.q);
		if (str) usp.set("q", str);
	}
}

//#endregion
export { parseListParams };
//# sourceMappingURL=index.js.map